import React, { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import "../components/Table/Table.css";
import { TextField, TablePagination, Button } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import pdfLogo from "../images/login1.png";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { useTranslation } from "react-i18next";


const UniqueCodeReport = ({ role }) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const dataArray = [
    {
        "school_name": "Khaliapali AS",
        "UDISE_code": "21010303403",
        "hostel_type": "100 STGH",
        "Hostel_Unique_Code": "347/3312/03/01",
        "Header_master_name": "Manoj",
        "Contact_no": 9999888200
    },
    {
        "school_name": "Kainsir AS",
        "UDISE_code": "21010402402",
        "hostel_type": "100 STGH",
        "Hostel_Unique_Code": "347/3313/02/02",
        "Header_master_name": "John Doe",
        "Contact_no": 9876543210
    },
    {
        "school_name": "Bhinjatora AS",
        "UDISE_code": "21010505301",
        "hostel_type": "100 STGH",
        "Hostel_Unique_Code": "347/3314/01/03",
        "Header_master_name": "Jane Smith",
        "Contact_no": 8765432109
    },
    {
        "school_name": "Saipali AS",
        "UDISE_code": "21010709102",
        "hostel_type": "100 STGH",
        "Hostel_Unique_Code": "347/3316/02/04",
        "Header_master_name": "Michael Johnson",
        "Contact_no": 7654321098
    },
    {
        "school_name": "Laudidhara AS",
        "UDISE_code": "21010908401",
        "hostel_type": "200 STGH",
        "Hostel_Unique_Code": "347/3318/01/05",
        "Header_master_name": "Sarah Lee",
        "Contact_no": 6543210987
    },
    {
        "school_name": "Kecchodader SS",
        "UDISE_code": "21011007202",
        "hostel_type": "100 STGH",
        "Hostel_Unique_Code": "347/3320/02/06",
        "Header_master_name": "David Brown",
        "Contact_no": 5432109876
    },
    {
        "school_name": "Loharpalli AS",
        "UDISE_code": "21011109501",
        "hostel_type": "200 STGH",
        "Hostel_Unique_Code": "347/3319/02/07",
        "Header_master_name": "Emily Wilson",
        "Contact_no": 4321098765
    },
    {
        "school_name": "Sargipalli AS",
        "UDISE_code": "21011104901",
        "hostel_type": "100 STGH",
        "Hostel_Unique_Code": "373/3584/01/08",
        "Header_master_name": "Christopher Martinez",
        "Contact_no": 3210987654
    },
    {
        "school_name": "Dimiriposhi AS",
        "UDISE_code": "21040113202",
        "hostel_type": "100 STBH",
        "Hostel_Unique_Code": "351/3346/02/09",
        "Header_master_name": "Amanda Taylor",
        "Contact_no": 2109876543
    },
    {
        "school_name": "Dimiriposhi AS",
        "UDISE_code": "21040113202",
        "hostel_type": "100 STGH",
        "Hostel_Unique_Code": "351/3346/02/10",
        "Header_master_name": "Daniel Clark",
        "Contact_no": 1098765432
    }
];

  useEffect(() => {
    const filtered = dataArray.filter(
      (item) =>
        item.hostel_type.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.school_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.UDISE_code.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.Hostel_Unique_Code.toLowerCase().includes(
          searchQuery.toLowerCase()
        )
    );
    setFilteredData(filtered);
    setPage(0);
  }, [searchQuery]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const exportPDF = () => {
    const doc = new jsPDF("landscape", "pt", "letter");

    const title = "SC/ST Department, Odisha";
    const reportName = "Hostel Unique Code Report";
    const tableColumn = [
      "Sr. No.",
      "School Name",
      "UDISE code",
      "Hostel Type",
      "Hostel Unique Code",
      "Head Master Name",
      "Contact Head Master",

    ];
    const tableRows = [];

    // Load your logo (replace 'path/to/your/logo.png' with actual path or base64 string)
    const logoUrl = pdfLogo; // Change this URL or use base64 image data
    doc.addImage(logoUrl, "PNG", 10, 10, 30, 30); // Adjust dimensions as needed

    // Calculate the center position for the title vertically with respect to the logo
    const titleHeight = 10 + 15; // Adjust this depending on your logo's height + some margin
    const titleRepHeight = 10 + 50;
    const titleWidth =
      (doc.getStringUnitWidth(title) * doc.internal.getFontSize()) /
      doc.internal.scaleFactor;
      const fromLeft = 330; // Adjust depending on the size and placement of your logo
      const fromRepLeft = 40;

    filteredData.forEach((row, index) => {
      const rowData = [
        index + 1,
        row.school_name,
        row.UDISE_code,
        row.hostel_type,
        row.Hostel_Unique_Code,
        row.Header_master_name,
        row.Contact_no,
      ];
      tableRows.push(rowData);
    });

    doc.setFontSize(16); // Sets the font size to 16 points for the title
    doc.text(title, fromLeft, titleHeight); // Position the title next to the logo
    doc.setFontSize(12);
    doc.text(reportName, fromRepLeft, titleRepHeight);
    doc.setFontSize(12); // Resets the font size for the table
    doc.autoTable(tableColumn, tableRows, { startY: 70 }); // Start the table 100px below the logo and title
    doc.save("hostel_unique_code_report.pdf");
  };

  const exportExcel = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Unique Code Report");

    // Add title
    worksheet.mergeCells("A1:E1");
    const titleRow = worksheet.getRow(1);
    titleRow.getCell(1).value = "Unique Code Report";
    titleRow.getCell(1).font = { bold: true, size: 16 };
    titleRow.getCell(1).alignment = { horizontal: "center" };

    // Add headers
    const headers = [
      "Sr. No.",
      "School Name",
      "UDISE code",
      "Hostel Type",
      "Hostel Unique Code",
      "Head Master Name",
      "Contact Head Master"
    ];
    // worksheet.addRow([]); // Add empty row for spacing
    const headerRow = worksheet.addRow(headers);
    headerRow.eachCell((cell) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "003366" }, // Blue background color
      };
      cell.font = {
        color: { argb: "FFFFFF" }, // White text color
        bold: true,
      };
    });

    // Add data
    filteredData.forEach((row, index) => {
      worksheet.addRow([
        index + 1,
        row.school_name,
        parseInt(row.UDISE_code),
        row.hostel_type,
        parseInt(row.Hostel_Unique_Code),
        row.Header_master_name,
        parseInt(row.Contact_no)

      ]);
    });

    // Set workbook properties
    workbook.creator = "Your Name";
    workbook.lastModifiedBy = "Your Name";
    workbook.created = new Date();
    workbook.modified = new Date();

    // Generate Excel file
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const fileName = "hostel_unique_code_report.xlsx";
      saveAs(blob, fileName);
    });
  };

  const getSerialNumber = (index) => {
    return page * rowsPerPage + index + 1;
  };

  return (
    <>
      <div className="px-0 px-md-3">
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <h5 className="mt-4">{t("Hostel Unique Code Report")}</h5>
          <div className="mb-3">
            <TextField
              label={t("Search")}
              variant="outlined"
              fullWidth
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              InputProps={{
                endAdornment: <SearchIcon />,
              }}
              style={{
                width: "17rem",
                marginTop: "20px",
              }}
            />
          </div>
        </div>

        <div class="col-md-12 mt-4 d-flex">
          <div class="d-flex justify-content-start align-items-center">
            <Button variant="contained" color="primary" onClick={exportPDF}>
              {t("Download PDF")}
            </Button>
            <span class="mx-2"></span>
            <Button variant="contained" color="success" onClick={exportExcel}>
              {t("Download Excel")}
            </Button>
          </div>
        </div>

        <div className="Table mb-6">
          <TableContainer
            component={Paper}
            style={{ boxShadow: "0px 13px 20px 0px #80808029" }}
            className="my-4"
          >
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>{t("Sr. No.")}</TableCell>
                  <TableCell align="left">{t("School Name")}</TableCell>
                  <TableCell align="left">{t("UDISE code")}</TableCell>
                  <TableCell align="left">{t("Hostel Type")}</TableCell>
                  <TableCell align="left">{t("Hostel Unique Code")}</TableCell>
                  <TableCell align="left">{t("Head Master Name")}</TableCell>
                  <TableCell align="left">{t("Contact Head Master")}</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {filteredData
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => (
                    <TableRow key={index}>
                      <TableCell component="th" scope="row">
                        {getSerialNumber(index)}
                      </TableCell>
                      <TableCell align="left">{row.school_name}</TableCell>
                      <TableCell align="left">{row.UDISE_code}</TableCell>
                      <TableCell align="left">{row.hostel_type}</TableCell>
                      <TableCell align="left">
                        {row.Hostel_Unique_Code}
                      </TableCell>
                      <TableCell align="left">{row.Header_master_name}</TableCell>
                      <TableCell align="left">{row.Contact_no}</TableCell>


                      
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 50]}
            component="div"
            count={filteredData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      </div>
    </>
  );
};

export default UniqueCodeReport;
